import { Injectable } from '@angular/core';
import { IntegrationPlatform } from '@app/onboarding/store/integrations.service';

@Injectable({
  providedIn: 'root',
})
export class PlatformIconService {
  saleChannels(): IntegrationPlatform[] {
    return [
      'woocommerce',
      'prestashop',
      'smartweb',
      'wannafind',
      'scannet',
      'magento',
      'magento_2',
      'dandomain',
      'dandomain_2',
      'golden-planet',
    ];
  }

  deprecatedPlatforms() {
    return ['smartweb', 'dandomain', 'scannet', 'magento', 'wannafind', 'dandomain_2', 'golden-planet'];
  }

  whiteIcons() {
    return [
      'wannafind',
      'scannet',
      'nets-easy',
      'altapay',
      'dandomain_2',
      'quickpay',
      'onpay',
      'swiipe',
      'golden-planet',
    ];
  }

  accounting() {
    return ['billy', 'dinero', 'economic', 'uniconta', 'zenegy'];
  }

  gateways() {
    return ['quickpay', 'onpay', 'altapay', 'swiipe', 'freepay', 'reepay', 'pensopay', 'vipps'];
  }

  betaGateways() {
    return [];
  }

  acquirers() {
    return ['stripe', 'clearhaus', 'nets', 'shopify', 'nets-easy', 'klarna', 'altapay', 'rapyd', 'elavon'];
  }

  betaAcquirers() {
    return [];
  }

  hostedshopList() {
    return ['smartweb', 'scannet', 'dandomain_2', 'wannafind'];
  }

  mailers() {
    return ['sproom'];
  }

  public getById(platform: string) {
    const iconPath = 'assets/btn/';
    let iconFile: string;
    switch (platform) {
      case 'altapay':
        iconFile = 'btn-altapay.svg';
        break;
      case 'quickpay':
        iconFile = 'btn-quickpay.svg';
        break;
      case 'onpay':
        iconFile = 'btn-onpay.svg';
        break;
      case 'billy':
        iconFile = 'btn-billy.svg';
        break;
      case 'clearhaus':
        iconFile = 'btn-clearhaus.svg';
        break;
      case 'danaweb':
        iconFile = 'btn-danaweb.svg';
        break;
      case 'dandomain':
        iconFile = 'btn-dandomain-classic.svg';
        break;
      case 'danhost':
        iconFile = 'btn-danhost.svg';
        break;
      case 'dinero':
        iconFile = 'btn-dinero.svg';
        break;
      case 'economic':
        iconFile = 'btn-e-conomic.svg';
        break;
      case 'magento':
        iconFile = 'btn-magento.svg';
        break;
      case 'magento_2':
        iconFile = 'btn-magento2.svg';
        break;
      case 'prestashop':
        iconFile = 'btn-prestashop.svg';
        break;
      case 'salecto':
        iconFile = 'btn-salecto.svg';
        break;
      case 'scannet':
        iconFile = 'btn-scannet.svg';
        break;
      case 'shopify':
        iconFile = 'btn-shopify.svg';
        break;
      case 'smartweb':
        iconFile = 'btn-smartweb.svg';
        break;
      case 'stripe':
        iconFile = 'btn-stripe.svg';
        break;
      case 'wannafind':
        iconFile = 'btn-wannafind.svg';
        break;
      case 'woocommerce':
        iconFile = 'btn-woocommerce.svg';
        break;
      case 'nets':
        iconFile = 'btn-nets.svg';
        break;
      case 'shopify-payment':
        iconFile = 'btn-shopify-payments.svg';
        break;
      case 'nets-easy':
        iconFile = 'btn-nets-easy.png';
        break;
      case 'klarna':
        iconFile = 'btn-klarna.svg';
        break;
      case 'swiipe':
        iconFile = 'btn-swiipe.svg';
        break;
      case 'dandomain_2':
        iconFile = 'btn-dandomain.svg';
        break;
      case 'freepay':
        iconFile = 'btn-freepay.svg';
        break;
      case 'reepay':
        iconFile = 'btn-reepay.svg';
        break;
      case 'rapyd':
        iconFile = 'btn-rapyd.svg';
        break;
      case 'uniconta':
        iconFile = 'btn-uniconta.svg';
        break;
      case 'pensopay':
        iconFile = 'btn-pensopay.svg';
        break;
      case 'zenegy':
        iconFile = 'btn-zenegy.png';
        break;
      case 'sproom':
        iconFile = 'btn-sproom.png';
        break;
      case 'elavon':
        iconFile = 'btn-elavon.svg';
        break;
      case 'golden-planet':
        iconFile = 'btn-goldenplanet.svg';
        break;
      case 'vipps':
        iconFile = 'btn_vipps_mobilepay.svg';
        break;
      default:
        iconFile = 'btn-storebuddy-full.svg';
    }
    return iconPath + iconFile;
  }

  public getAcquirerById(platform: string) {
    const iconPath = 'assets/btn/';
    let iconFile: string;
    switch (platform) {
      case 'altapay':
        iconFile = 'btn-altapay.svg';
        break;
      case 'clearhaus':
        iconFile = 'btn-clearhaus.svg';
        break;
      case 'stripe':
        iconFile = 'btn-stripe.svg';
        break;
      case 'nets':
        iconFile = 'btn-nets.svg';
        break;
      case 'shopify':
        iconFile = 'btn-shopify-payments.svg';
        break;
      case 'nets-easy':
        iconFile = 'btn-nets-easy.png';
        break;
      case 'klarna':
        iconFile = 'btn-klarna.svg';
        break;
      case 'rapyd':
        iconFile = 'btn-rapyd.svg';
        break;
      case 'elavon':
        iconFile = 'btn-elavon.svg';
        break;
      default:
        iconFile = 'btn-storebuddy-full.svg';
    }
    return iconPath + iconFile;
  }
}
